import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneroundtripcabservice() {



  const cardData = {
"keyword": "Pune Round Trip Cab Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune Round Trip Cab Service for travelers who need flexible, safe, and convenient transportation with a return journey included. Whether you are planning a family trip, business visit, pilgrimage, weekend getaway, airport transfer, or multi-day tour, our cab service ensures a smooth and stress-free travel experience both ways. With experienced drivers who are well-versed with highway routes, hill roads, and intercity travel, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to various destinations and back. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible round-trip packages, waiting time options, doorstep pickup and drop, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and well-planned round-trip travel experience.",

"topPlaces": [
  {
    "title": "Mumbai",
    "description":
      "Mumbai is a major round-trip destination from Pune known for business meetings, tourism, shopping, and cultural attractions. Travelers often book round-trip cabs for same-day or overnight visits."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a popular pilgrimage destination dedicated to Sai Baba. Many devotees prefer round-trip cab services from Pune for darshan and return journey on the same or next day."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is known for Trimbakeshwar Jyotirlinga, vineyards, and religious tourism. It is a frequently booked round-trip cab destination from Pune for both spiritual and leisure travel."
  },
  {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are scenic hill stations near Pune popular for one-day and weekend round-trip cab packages, offering waterfalls, viewpoints, and pleasant weather."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a famous hill station known for its cool climate, strawberry farms, and viewpoints. Round-trip cabs from Pune are commonly booked for 1–2 day tours."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal destination known for beaches and forts. Round-trip cab services from Pune are ideal for weekend beach holidays and quick getaways."
  },
  {
    "title": "Kolhapur",
    "description":
      "Kolhapur is famous for Mahalaxmi Temple, heritage sites, and cultural significance. It is a popular long-distance round-trip cab destination from Pune."
  },
  {
    "title": "Aurangabad",
    "description":
      "Aurangabad is known for Ajanta and Ellora Caves, Bibi Ka Maqbara, and historical tourism. Round-trip cab services are commonly used for heritage tours from Pune."
  },
  {
    "title": "Satara",
    "description":
      "Satara is known for Kaas Plateau, Ajinkyatara Fort, and scenic Sahyadri views. It is a popular short-distance round-trip destination from Pune."
  },
  {
    "title": "Pune Intercity Return Route Network",
    "description":
      "Pune round-trip cab services cover major cities, hill stations, pilgrimage sites, and coastal destinations across Maharashtra, offering flexible return travel options for comfort, safety, and convenience."
  }
],



services: [
  {
    name: "Pune Round Trip Cab",
    description: "Pune round trip cab service provides reliable transportation for passengers planning return journeys from Pune to various outstation destinations. Comfortable vehicles with experienced drivers ensure smooth highway travel for families, tourists, corporate travelers, and local passengers. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient round trip cab reservations."
  },
  {
    name: "Pune Return Taxi Service",
    description: "Pune return taxi service offers dependable transportation for return travel with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for business trips, family travel, tourism, and intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient return taxi reservations."
  },
  {
    name: "Round Trip Taxi Pune",
    description: "Round trip taxi Pune service provides comfortable transportation for passengers requiring two-way travel from Pune to outstation destinations and back. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth travel journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and nearby locations across Pune. Ideal for business travelers, tourists, and family travel requirements. Flexible booking options allow convenient round trip taxi reservations."
  },
  {
    name: "Pune Outstation Round Trip Cab",
    description: "Pune outstation round trip cab service offers reliable transportation with comfortable vehicles and professional drivers for return journeys from Pune. Vehicles provide smooth city and highway travel suitable for tourism, business visits, pilgrimage tours, and family travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available directly from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy outstation round trip cab reservations."
  },
  {
    name: "Pune Full Day Round Trip Cab",
    description: "Pune full day round trip cab service provides dependable transportation solutions for passengers planning same-day return travel from Pune. Vehicles are suitable for long-distance travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for business travel, tourism trips, and family outstation travel. Flexible booking options allow convenient full-day round trip cab reservations."
  },
  {
    name: "Best Pune Round Trip Taxi",
    description: "Best Pune round trip taxi service provides transparent and reliable transportation for travelers needing comfortable two-way travel services from Pune. Travelers can enjoy smooth journeys with experienced drivers familiar with highway routes and traffic conditions. Comfortable vehicles ensure timely travel with safe transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient round trip taxi reservations."
  },
  {
    name: "Cheap Pune Round Trip Cab",
    description: "Cheap Pune round trip cab service provides economical and comfortable transportation for travelers planning affordable return journeys from Pune. Comfortable vehicles ensure smooth highway travel suitable for business trips, tourism, and family travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient low-cost round trip cab reservations."
  },
  {
    name: "SUV Pune Round Trip Taxi",
    description: "SUV Pune round trip taxi service offers spacious transportation for families and groups traveling from Pune to various destinations and back. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for family outings and outstation travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV round trip taxi reservations."
  },
  {
    name: "Innova Pune Round Trip Cab",
    description: "Innova Pune round trip cab service provides premium SUV transportation for passengers seeking comfortable and reliable return travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, business trips, and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova round trip cab reservations."
  },
  {
    name: "Sedan Pune Round Trip Taxi",
    description: "Sedan Pune round trip taxi service offers economical and comfortable transportation for solo travelers, couples, and small families traveling from Pune to outstation destinations and back. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for return journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient sedan taxi reservations."
  },
  {
    name: "Pune Intercity Round Trip Cab",
    description: "Pune intercity round trip cab service offers dependable transportation for passengers planning return travel between Pune and nearby cities. Comfortable vehicles ensure smooth highway travel suitable for tourism, business travel, and family trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient intercity round trip cab reservations."
  },
  {
    name: "Pune Long Distance Return Cab",
    description: "Pune long distance return cab service provides reliable transportation for travelers planning long-distance return journeys from Pune to various cities and destinations. Comfortable vehicles ensure smooth and safe travel suitable for tourists, families, business travelers, and airport visitors. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient long-distance return cab reservations."
  },
  {
    name: "Pune Round Trip Booking Cab",
    description: "Pune round trip booking cab service offers comfortable transportation for passengers looking for advance round trip travel reservations from Pune. Vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for business trips, family tours, and outstation travel requirements. Flexible booking options allow convenient booking cab reservations."
  },
  {
    name: "Flexible Round Trip Taxi Pune",
    description: "Flexible round trip taxi Pune service provides dependable transportation for passengers planning customizable return travel schedules from Pune. Comfortable vehicles ensure smooth highway travel suitable for tourism, airport visits, and corporate travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient flexible round trip taxi reservations."
  },
  {
    name: "Pune Travel Round Trip Cab",
    description: "Pune travel round trip cab service provides affordable and convenient transportation for passengers traveling between Pune and nearby cities with return travel options. Vehicles ensure reliable highway travel with experienced drivers offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for business travelers, tourists, and family outstation travel requirements. Flexible booking options allow convenient travel round trip cab reservations."
  }
],

tableData: [
  ["Pune Round Trip Cab", "Pune Return Taxi Service"],
  ["Round Trip Taxi Pune", "Pune Outstation Round Trip Cab"],
  ["Pune Full Day Round Trip Cab", "Best Pune Round Trip Taxi"],
  ["Cheap Pune Round Trip Cab", "SUV Pune Round Trip Taxi"],
  ["Innova Pune Round Trip Cab", "Sedan Pune Round Trip Taxi"],
  ["Pune Intercity Round Trip Cab", "Pune Long Distance Return Cab"],
  ["Pune Round Trip Booking Cab", "Flexible Round Trip Taxi Pune"],
  ["Pune Travel Round Trip Cab", "Pune Round Trip Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune Round Trip Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune Round Trip cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe return journeys."
      },
      {
        WhyChooseheading: "Affordable Round Trip Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune Round Trip cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Round Trip Cab Availability",
        WhyChoosedescription: "Our Pune Round Trip cab service operates 24 hours a day for outstation travel, business trips, family vacations, pilgrimage tours, airport transfers, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Taxis",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences."
      },
      {
        WhyChooseheading: "Flexible Round Trip Travel Options",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including same-day return trips, multi-day round trips, sightseeing tours, business travel, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Taxi Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, tourists, and corporate travelers."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Highway Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with major highway routes and tourist destinations, ensuring safe driving, smooth travel, and timely return journeys."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune Round Trip cab service?", answer: "Pune Round Trip cab service provides comfortable taxi transportation for return journeys between Pune and local or outstation destinations." },
    { question: "Is Pune Round Trip cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune Round Trip cab service." },
    { question: "Which vehicles are available for round trip travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book round trip taxi service for outstation travel?", answer: "Yes, customers can book round trip taxi services for sightseeing, business travel, pilgrimage tours, and vacations." },
    { question: "Do you provide same-day return cab service?", answer: "Yes, Shivai Travels provides same-day return as well as multi-day round trip taxi services." },
    { question: "Are all Pune Round Trip taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune Round Trip cab service online?", answer: "Yes, customers can easily book Pune Round Trip cab service online or through phone booking." },
    { question: "Do you provide taxis for family and corporate travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and corporate transportation." },
    { question: "Are Pune Round Trip cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune Round Trip cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rahul Patil",
      feedback:
        "Booked Pune Round Trip cab service with Shivai Travels. Comfortable vehicle, smooth journey, and excellent driver support throughout the trip.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Poonam Deshmukh",
      feedback:
        "Excellent Pune Round Trip taxi service. Affordable pricing, clean cab, and wonderful travel experience.",
      rating: 5
    }
  ];











  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Round Trip Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-round-trip-cab.jpg",
  "description": "Book Pune Round Trip Cab Service for comfortable and flexible return travel. Shivai Travels offers reliable round-trip taxi booking for outstation and intercity trips with sedan, SUV, Innova, and luxury cab options available 24x7 for long-distance travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-round-trip-cab-service"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune Round Trip Cab Service | Return Taxi Booking | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune Round Trip Cab Service for flexible return travel. Affordable outstation and intercity round-trip taxi options with sedan, SUV, Innova, and luxury cabs available 24x7."
  />

  <meta
    name="keywords"
    content="pune round trip cab, pune return taxi service, round trip taxi pune, pune outstation round trip cab, pune full day round trip cab, best pune round trip taxi, cheap pune round trip cab, suv pune round trip taxi, innova pune round trip cab, sedan pune round trip taxi, pune intercity round trip cab, pune long distance return cab, pune round trip booking cab, flexible round trip taxi pune, pune travel round trip cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/99.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneroundtripcabservice;